import { actionTypes } from "./commonTypes";


export const initialState: commonReducerType = {
  showSidebar: true,
  isHideDownloadModal: false
};

type commonReducerType = {
  showSidebar: boolean;
  isHideDownloadModal: boolean;
};

const commonReducer = (state = initialState, { type, payload }: any): commonReducerType => {
  switch (type) {
    case actionTypes.SET_VISIBLE_SIDEBAR:
      return {
        ...state,
        showSidebar: payload
      };
    case actionTypes.SET_IS_HIDE_DOWNLOAD_MODAL:
      return {
        ...state,
        isHideDownloadModal: payload
      };
    default:
      return state;
  }
};

export default commonReducer;
